import React from "react";
import { Alert } from "@material-ui/lab";
import { styled } from "@material-ui/core";
import ReportIcon from "@material-ui/icons/Report";
//import Snackbar from "@material-ui/core/Snackbar";
//import { useSelector } from "react-redux";
//import Modal from "react-bootstrap/Modal";
const StyledAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: "#fcbca0", // your custom color
}));
const Unauthorized = () => {
  // const { subDomain } = useSelector((state) => state.login);
  // const logOut = () => {
  //   window.location.href = `${subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`;
  // };
  return (
    <div className="dash-layout">
      <div className="container" id="unauth">
        {/* <Modal
          show={true}
          backdrop="static"
          // onHide={() => yesHandler()}
          centered
        >
          <Modal.Body>
            <>
              <h4 class="section-head">Unauthorized</h4>
              <div>
                <p>
                  You don't have permission to access this page. please contact
                  your administrator for access.
                </p>
              </div>

              <button
                onClick={() => logOut()}
                className="btn-primary-continue mr-3 idle-yes float-right"
              >
                OK
              </button>
            </>
          </Modal.Body>
        </Modal> */}
        <StyledAlert severity="error" icon={<ReportIcon fontSize="large" />}>
          You don't have permission to access this page. please contact your
          administrator for access.
        </StyledAlert>
      </div>
    </div>
  );
};
export default Unauthorized;
